import React from "react";

const SummaryEmail = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F6F8FA" />
      <path
        d="M20 21.5V23C18.8065 23 17.6619 23.4741 16.818 24.318C15.9741 25.1619 15.5 26.3065 15.5 27.5H14C14 25.9087 14.6321 24.3826 15.7574 23.2574C16.8826 22.1321 18.4087 21.5 20 21.5ZM20 20.75C17.5137 20.75 15.5 18.7362 15.5 16.25C15.5 13.7638 17.5137 11.75 20 11.75C22.4862 11.75 24.5 13.7638 24.5 16.25C24.5 18.7362 22.4862 20.75 20 20.75ZM20 19.25C21.6575 19.25 23 17.9075 23 16.25C23 14.5925 21.6575 13.25 20 13.25C18.3425 13.25 17 14.5925 17 16.25C17 17.9075 18.3425 19.25 20 19.25ZM21.9462 25.109C21.8512 24.7088 21.8512 24.2919 21.9462 23.8917L21.2022 23.462L21.9522 22.163L22.6962 22.5927C22.9949 22.3099 23.3558 22.1013 23.75 21.9838V21.125H25.25V21.9838C25.649 22.1023 26.009 22.3138 26.3037 22.5927L27.0477 22.163L27.7977 23.462L27.0537 23.8917C27.1487 24.2917 27.1487 24.7083 27.0537 25.1083L27.7977 25.538L27.0477 26.837L26.3037 26.4072C26.0051 26.6901 25.6442 26.8987 25.25 27.0162V27.875H23.75V27.0162C23.3558 26.8987 22.9949 26.6901 22.6962 26.4072L21.9522 26.837L21.2022 25.538L21.9462 25.109ZM24.5 25.625C24.7984 25.625 25.0845 25.5065 25.2955 25.2955C25.5065 25.0845 25.625 24.7984 25.625 24.5C25.625 24.2016 25.5065 23.9155 25.2955 23.7045C25.0845 23.4935 24.7984 23.375 24.5 23.375C24.2016 23.375 23.9155 23.4935 23.7045 23.7045C23.4935 23.9155 23.375 24.2016 23.375 24.5C23.375 24.7984 23.4935 25.0845 23.7045 25.2955C23.9155 25.5065 24.2016 25.625 24.5 25.625Z"
        fill="#525866"
      />
    </svg>
  );
};

export default SummaryEmail;
